export default (state = {}, { type, payload }) => {
    switch (type) {
        case 'HUNT_PLANNER_FILTER_OPTIONS':
            return payload
        case 'LOGOUT':
            return null
        default:
            return state
    }
}